<!-- Campo -->
<div>
  <div id="google-container">
    <input
      id="field-google-autocomplete"
      type="search"
      [(ngModel)]="autocompleteInput"
      (keyup)="searchAddress()"
      [placeholder]="placeholder"
      autocomplete="off"
      [disabled]="isDisabled"
      (click)="searchAddress()"
    />
  </div>

  <!-- Predicciones -->
  <div
    id="predictions"
    *ngIf="
      predictions != null && autocompleteInput && autocompleteInput.length > 0
    "
  >
    <a
      class="prediction"
      *ngFor="let prediction of predictions"
      (click)="predictionSelected(prediction)"
      matRipple
    >
      <div class="location-icon"></div>
      <p
        *ngIf="searchToHighlight; else searchNoHighlight"
        [innerHTML]="prediction.description"
      ></p>

      <!-- [markjsHighlight]="searchToHighlight" -->

      <ng-template #searchNoHighlight>
        <p [innerHTML]="prediction.description"></p>
      </ng-template>
    </a>
    <img
      id="powered-by-google"
      src="/assets/images/powered_by_google.png"
      alt="Powered by Google"
    />
  </div>
</div>
